<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />">
</ngx-spinner>

<div class="sfdc-configuration-content">
  <div class="content-top-box">
    <app-bread-crumb></app-bread-crumb>
  </div>
  <div class="header-title">
    <h1 class="main-title">
      {{
      langObj
      ? langObj?.TechnicianExecution
      : ("TechnicianExecution" | translate)
      }}
    </h1>
  </div>
</div>

<div class="w-100">
  <form [formGroup]="technicianForm">
    <div class="w-100 techForm">
      <mat-form-field class="w-18">
        <mat-label>{{
          langObj ? langObj?.linearea : ("linearea" | translate)
          }}</mat-label>
        <input required matInput type="text" formControlName="line_area" [(ngModel)]="technician.LineArea" />
        <mat-error *ngIf="f.line_area.hasError('required')">{{ langObj ? langObj?.linareareq : ("linareareq" |
          translate) }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-9">
        <mat-label>{{
          langObj ? langObj?.WOId : ("WOId" | translate)
          }}</mat-label>
        <input required matInput type="text" formControlName="wo_id" [(ngModel)]="technician.DisplayWOId" />
        <mat-error *ngIf="f.wo_id.hasError('required')">{{ langObj ? langObj?.woisreq : ("woisreq" | translate) }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-9">
        <mat-label>{{
          langObj ? langObj?.WOStatus : ("WOStatus" | translate)
          }}</mat-label>
        <input required matInput formControlName="wo_status" [ngClass]="{
            'text-green': technician.WOStatus == 3 || technician.WOStatus == 2,
            'text-red':
              technician.WOStatus == 1 ||
              technician.WOStatus == 6 ||
              technician.WOStatus == 4 ||
              technician.WOStatus == 5,
            'text-orange': technician.WOStatus == 5
          }" [(ngModel)]="technician.WOStatusDisplay" />
        <mat-error *ngIf="f.wo_status.hasError('required')">
          {{
          langObj ? langObj?.wostatsreeq : ("wostatsreeq" | translate)
          }}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-18">
        <mat-label>{{
          langObj ? langObj?.WOType : ("WOType" | translate)
          }}</mat-label>
        <mat-select required [(ngModel)]="technician.WOType" formControlName="wo_type"
          (selectionChange)="getWOTypeFailureData()" [disabled]="isviewMode">
          <mat-option *ngFor="let type of woType" [value]="type.ID">
            {{ type.Name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="f.wo_type.hasError('required')">
          {{
          langObj ? langObj?.wotypereq : ("wotypereq" | translate)
          }}</mat-error>
      </mat-form-field>
      <mat-form-field class="w-18">
        <input formControlName="wo_creation_time" [(ngModel)]="technician.WOCreationTime" readonly matInput
          placeholder="Creation Time" required />
        <mat-error *ngIf="f.wo_creation_time.hasError('required')">
          {{ langObj ? langObj?.WOCreationTimeIsRequired : ("WOCreationTimeIsRequired" | translate) }}</mat-error>
      </mat-form-field>
      <mat-form-field class="w-16">
        <input formControlName="technician_assigned_time" [(ngModel)]="technician.TechnicianAssignedTime" readonly
          matInput placeholder="Technician Assigned Time" />
      </mat-form-field>
      <mat-form-field class="w-18">
        <mat-label>{{
          langObj ? langObj?.FailureMode : ("FailureMode" | translate)
          }}</mat-label>
        <mat-select required [(ngModel)]="technician.FailureMode" formControlName="faliure_mode"
          [disabled]="isviewMode">
          <mat-option *ngFor="let mode of failMode" [value]="mode.ID">
            {{ mode.Name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="f.faliure_mode.hasError('required')">{{ langObj ? langObj?.FailureModeisRequired :
          ("FailureModeisRequired" | translate) }}{{
          langObj
          ? langObj?.TechnicianExecution
          : ("TechnicianExecution" | translate)
          }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-18">
        <mat-label>{{
          langObj ? langObj?.Priority : ("Priority" | translate)
          }}</mat-label>
        <mat-select required [(ngModel)]="technician.Priority" formControlName="priority" [disabled]="isviewMode">
          <mat-option *ngFor="let Priority of PriorityList" [value]="Priority.ID">
            {{ Priority.Name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="f.priority.hasError('required')">{{ langObj ? langObj?.priisreq : ("priisreq" | translate) }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-18">
        <mat-label>{{
          langObj ? langObj?.SpareParts : ("SpareParts" | translate)
          }}</mat-label>
        <mat-select [(ngModel)]="technician.SpareParts" formControlName="spare_parts"
          (selectionChange)="setValidateSparePartsCode()" [disabled]="isviewMode"
          [required]="technician.SpareParts === 1">
          <mat-option *ngFor="let sp of spareParts" [value]="sp.ID">
            {{ sp.Name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="f.spare_parts.hasError('required')">{{ langObj ? langObj?.spare_Isreq : ("spare_Isreq" |
          translate) }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-18">
        <mat-label>{{
          langObj ? langObj?.MachineBreakdown : ("MachineBreakdown" | translate)
          }}</mat-label>
        <mat-select [(ngModel)]="technician.MachineBreakdown" formControlName="machineBreakdown" [disabled]="isviewMode"
          required>
          <mat-option *ngFor="let sp of spareParts" [value]="sp.ID">
            {{ sp.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-18">
        <mat-label>{{
          langObj ? langObj?.SparePartCode : ("SparePartCode" | translate)
          }}</mat-label>
        <input matInput formControlName="spare_part_code" [(ngModel)]="technician.SparePartCode" [readonly]="isviewMode"
          required />
        <mat-error *ngIf="f.spare_part_code.hasError('required')">{{
          langObj ? langObj?.sparecodeisreq : ("sparecodeisreq" | translate)
          }}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-18">
        <input formControlName="wo_closed_time" [(ngModel)]="technician.WOClosedTime" readonly matInput
          placeholder="Closed Time" />
        <mat-error *ngIf="f.wo_closed_time.hasError('required')">
          {{langObj ? langObj?.WOClosedTimeIsRequired : ("WOClosedTimeIsRequired" | translate)}}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-38" style="margin-right: 1%">
        <mat-label>{{
          langObj ? langObj?.OperatorRemark : ("OperatorRemark" | translate)
          }}</mat-label>
        <textarea matInput [(ngModel)]="technician.Remark" formControlName="remarks" required></textarea>
        <mat-error *ngIf="f.remarks.hasError('required')">
          {{
          langObj ? langObj?.remarkisreq : ("remarkisreq" | translate)
          }}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-38">
        <mat-label>{{langObj ? langObj?.SupervisorRemark : ("SupervisorRemark" | translate)}}</mat-label>
        <textarea matInput [(ngModel)]="technician.SupervisorRemark" formControlName="visorremarks" required></textarea>
        <mat-error *ngIf="f.visorremarks.hasError('required')">
          {{langObj ? langObj?.SupervisorRemarkIsRequired : ("SupervisorRemarkIsRequired" | translate)}}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="w-100 techForm main-form">
      <mat-form-field class="w-22 date-time">
        <mat-label>{{
          langObj ? langObj?.StartTime : ("StartTime" | translate)
          }}</mat-label>
        <input matInput readonly [ngxMatDatetimePicker]="picker" formControlName="start_time"
          [(ngModel)]="technician.StartTime" [disabled]="disableStartTime" (dateChange)="dateChanged('starttime')" required />
        <mat-datepicker-toggle matSuffix [for]="$any(picker)"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #picker [enableMeridian]="true"></ngx-mat-datetime-picker>
        <mat-error *ngIf="f.start_time.hasError('required')">{{
          langObj ? langObj?.starttimeisreq : ("starttimeisreq" | translate)
          }}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-22 date-time">
        <mat-label>{{
          langObj ? langObj?.SPrequestTime : ("SPrequestTime" | translate)
          }}</mat-label>
        <input matInput readonly [ngxMatDatetimePicker]="picker3" formControlName="sp_req_time"
          [(ngModel)]="technician.SPRequestTime" [disabled]="isviewMode" (dateChange)="dateChanged('spRequest')" />
        <mat-datepicker-toggle matSuffix [for]="$any(picker3)"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #picker3 [enableMeridian]="true"></ngx-mat-datetime-picker>
        <mat-error *ngIf="f.sp_req_time.hasError('required') && technician.SparePartCode=='No'">{{
          langObj ? langObj?.Spreqtimeisreq : ("Spreqtimeisreq" | translate)
          }}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-22 date-time">
        <mat-label>{{
          langObj ? langObj?.SPReceivedTime : ("SPReceivedTime" | translate)
          }}</mat-label>
        <input matInput readonly [ngxMatDatetimePicker]="picker4" formControlName="sp_rec_time"
          [(ngModel)]="technician.SPReceivedTime" [disabled]="isviewMode" (dateChange)="dateChanged('spReceived')" />
        <mat-datepicker-toggle matSuffix [readonly]="isviewMode" [for]="$any(picker4)"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #picker4 [enableMeridian]="true"></ngx-mat-datetime-picker>
        <mat-error *ngIf="f.sp_rec_time.hasError('required')">{{
          langObj
          ? langObj?.sprecievetimeisreq
          : ("sprecievetimeisreq" | translate)
          }}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-22 date-time">
        <mat-label>{{
          langObj ? langObj?.CompleteTime : ("CompleteTime" | translate)
          }}</mat-label>
        <input matInput readonly [ngxMatDatetimePicker]="picker2" formControlName="complete_time"
          [(ngModel)]="technician.CompleteTime" [disabled]="isviewMode" (dateChange)="dateChanged('completetime')" />
        <mat-datepicker-toggle matSuffix [for]="$any(picker2)"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #picker2 [enableMeridian]="true"></ngx-mat-datetime-picker>
        <mat-error *ngIf="f.complete_time.hasError('required')">{{
          langObj
          ? langObj?.TechnicianExecution
          : ("TechnicianExecution" | translate)
          }}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-50">
        <mat-label>{{
          langObj ? langObj?.WorkOrderDetails : ("WorkOrderDetails" | translate)
          }}</mat-label>
        <textarea matInput [(ngModel)]="technician.Remarks" formControlName="remarks_manual" [readonly]="isviewMode"
          maxlength="500"></textarea>
        <div class="hint-wrapper">
          <span class="max-char-hint">Max 500 characters</span>
          <mat-hint align="end" style="margin-left: 25px;">{{ technicianForm.value?.remarks_manual?.length || 0
            }}/500</mat-hint>
        </div>
      </mat-form-field>

      <button mat-flat-button color="accent" [disabled]="!isWrite" type="button" class="upload w-25"
        (click)="openFile()" *ngIf="!isviewMode">
        {{ langObj ? langObj?.AfterPicture : ("AfterPicture" | translate) }}
      </button>
      <input type="file" (change)="readFile($event)" class="d-none" #fileInput accept="image/*" multiple />

      <h2 *ngIf="
          (FileData && FileData.length) || (EditFileData && EditFileData.length)
        ">
        {{langObj ? langObj?.TechnicianImages : ("TechnicianImages" | translate)}}
      </h2>
      <div *ngIf="FileData && FileData.length" class="imgflex">
        <div *ngFor="let file of FileData; let i = index" class="relative">
          <div>
            <img *ngIf="file.FileType == 'image'" [src]="file.ImageSrc" alt="" width="250px" height="200px" />

          </div>

          <img src="assets/images/remove.png" (click)="removeFile(i)" class="absolute" alt="" width="20px"
            height="20px" />
        </div>
      </div>

      <div *ngIf="EditFileData && EditFileData.length" class="imgflex">
        <div *ngFor="let file of EditFileData; let i = index" class="relative">
          <div>
            <img [src]="blobStorageUrl+file.ImageSrc" alt="" width="250px" height="200px" (click)="imgview()">
          </div>

          <img *ngIf="!isviewMode" src="assets/images/delete.png" (click)="deleteFile(i)" class="absolute" alt=""
            width="20px" height="20px" />
        </div>
      </div>

      <h2 *ngIf="OperatorFiles && OperatorFiles.length"> {{langObj ? langObj?.OperatorImages : ("OperatorImages" |
        translate)}}</h2>
      <div *ngIf="OperatorFiles && OperatorFiles.length" class="imgflex">
        <div *ngFor="let file of OperatorFiles; let i = index" class="relative">
          <div>
            <img [src]="blobStorageUrl+file.ImageSrc" alt="" width="250px" height="200px" (click)="imgview1()">
          </div>
        </div>
      </div>

    </div>
    <div class="center w-100 my-2">
      <button class="submit" (click)="onSubmit()" *ngIf="(isUpdate | permissionChecker) && !isviewMode"
        type="submit float-right">
        {{ langObj ? langObj?.Submit : ("Submit" | translate) }}
      </button>
      <button class="cancel" routerLink="/PM/TechnicianExecutionWindow" [disabled]="!isWrite" type="button">
        {{langObj ? langObj?.Cancel : ("Cancel" | translate)}}
      </button>
    </div>
    <hr style="opacity: 0.3;margin-top: 20px;">
    <div class="w-100 prevForm">
      <mat-tab-group (selectedTabChange)="onTabChange($event)">

        <mat-tab>
          <ng-template mat-tab-label>
            {{langObj ? langObj?.ExternalWork : ('ExternalWork' | translate)}}
          </ng-template>
          <button style="margin-top: 10px;" mat-flat-button color="accent" (click)="openWOdialog()"
            [disabled]="taskStatus === 'Complete' || technician.ID == 0">
            {{langObj ? langObj?.AddExternalWork : ('AddExternalWork' | translate)}}
            {{langObj ? langObj?.AddWorkOrder : ('AddWorkOrder' | translate)}}</button>
          <ag-grid-angular style="width: 100%; height: 24vw; margin-top: 10px;" class="ag-theme-alpine"
            [rowData]="rowData" [columnDefs]="columnDefs" (gridReady)="onGridReady($event)"
            (cellClicked)="cellClicked($event)" [gridOptions]="gridOptions" [frameworkComponents]="frameworkComponents"
            [pagination]="true" [paginationPageSize]="10">
          </ag-grid-angular>
        </mat-tab>

        <!-- <mat-tab label="External Work">
                <app-prev-task-external-work></app-prev-task-external-work>
            </mat-tab> -->

      </mat-tab-group>
    </div>




  </form>
</div>

<!-- img popup -->
<ng-template #technicianimageViewModal>
  <button mat-mini-fab color="warn" (click)="oncloseimg()"><mat-icon>close</mat-icon></button>
  <mat-carousel timings="250ms ease-in" [autoplay]="false" interval="5000" color="accent" [loop]="true"
    [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true" [useMouseWheel]="true" orientation="ltr">
    <mat-carousel-slide #matCarouselSlide *ngFor="let file of EditFileData; let i = index"
      [image]="blobStorageUrl+file.ImageSrc" overlayColor="#00000040" [hideOverlay]="false"></mat-carousel-slide>
  </mat-carousel>
</ng-template>


<!-- end img popup -->

<ng-template #subTaskDialog>
  <div mat-dialog-title class="mat-title">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title" *ngIf="subtaskFormMode">Add Sub Task</h1>
      <h1 class="main-title" *ngIf="!subtaskFormMode">Update Sub Task</h1>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>

  <!-- Form -->
  <form [formGroup]="subTaskForm" (ngSubmit)="subtaskFormMode ? submitForm() : updateSubtaskForm()">
    <div class="w-100 prevForm">
      <input type="hidden" formControlName="Id">
      <!-- WO Details -->
      <mat-form-field appearence="fill" class="remarks" style="margin-top:10px;">
        <mat-label>WO Details<span> *</span></mat-label>
        <textarea matInput rows="3" type="text" formControlName="woDetails"
          placeholder="Enter Work Order details"> </textarea>
      </mat-form-field>

      <!-- Responsible (Dropdown of Technician Names) -->
      <mat-form-field class="w-22">
        <mat-label>Responsible<span> *</span></mat-label>
        <mat-select formControlName="responsible" (openedChange)="onPanelClose($event,'tech', machineSearchInput)">
          <input #machineSearchInput (keyup)="searchValues($event,'tech')" class="form-control w-100"
            placeholder="Search Technicians">
          <mat-option *ngFor="let tech of filteredTechnicianList" [value]="tech.id">
            {{ tech.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- Toggle to Choose Vendor Input Type -->
      <mat-slide-toggle #vendorElement class="w-22" style="margin-left: 30rem" [checked]="vendorToggle"
        (change)="onVendorToggleChange($event)">Add
        New Vendor
      </mat-slide-toggle>

      <!-- External Vendor Dropdown -->
      <mat-form-field *ngIf="vendorMode === 'existing'" style="margin-left: 30rem" class="w-22">
        <mat-label>Select External Vendor</mat-label>
        <mat-select formControlName="externalVendor" (openedChange)="onPanelClose($event,'vender', venderSearchInput)">
          <input #venderSearchInput (keyup)="searchValues($event,'vender')" class="form-control w-100"
            placeholder="Search Vendor">
          <mat-option *ngFor="let vendor of vendorsList" [value]="vendor.Id">
            {{ vendor.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- New Vendor Input -->
      <mat-form-field *ngIf="vendorMode === 'new'" style="margin-left: 30rem" class="w-22">
        <mat-label>Enter New Vendor</mat-label>
        <input matInput placeholder="Enter vendor name" formControlName="newVendorName" />
      </mat-form-field>



      <!-- Target Date -->
      <mat-form-field class="w-22">
        <mat-label>Target Date<span> *</span></mat-label>
        <input matInput [matDatepicker]="picker" formControlName="targetDate" [matDatepickerFilter]="disablePastDates"
          placeholder="Choose a date" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Buttons -->
    <div class="form-buttons mt-3">
      <button mat-flat-button color="accent" style="margin-top: .5rem;" *ngIf="subtaskFormMode"
        [disabled]="!subTaskForm.valid" type="submit">Submit</button>
      <button mat-flat-button color="accent" *ngIf="!subtaskFormMode" [disabled]="!subTaskForm.valid"
        type="submit">Update</button>
    </div>
  </form>
</ng-template>